import { ModuleWithProviders, NgModule } from '@angular/core';
import { PipesModule } from './lib/pipes/pipes.module';
import { LayoutsModule } from './layouts/layouts.module';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [],
    exports: [PipesModule, LayoutsModule, TranslateModule],
    providers: [DatePipe]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return { ngModule: SharedModule };
    }
}
